import { Fragment } from "react"
import { Outlet } from "react-router-dom"
import { ToastContainer } from "react-toastify"

const ContactsWrapper = () => {

    return (
        <Fragment>
            <ToastContainer />
            <Outlet />
        </Fragment>
    )
}

export default ContactsWrapper;